import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Link } from 'atoms/Link/Link';
import { ParseBBCode } from 'atoms/ParseBBCode';
import { Span } from 'atoms/Typography';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { DownloadLinkItem } from './type';
import styles from './DownloadLink.module.css';

export const DownloadLink: FC<DownloadLinkItem> = ({ name, href, refKey }) => {
  const { togglePageLoading } = useSiteConfig();

  if (!href) {
    return null;
  }

  return (
    <Link
      href={href}
      target="_blank"
      className={styles.container}
      onClick={() => togglePageLoading?.(false)}
    >
      <Span className={styles.content}>
        <Span className={styles.name}>
          <ParseBBCode content={name} />
        </Span>
        <Span className={styles.refKey}>{refKey}</Span>
      </Span>

      <Icon type={IconType.download} />
    </Link>
  );
};
